const Home = () => (
    <h4 className="text-center py-6"><i className="fas fa-info-circle mr-2 text-info" /> This page must be accessed via your admin dashboard.</h4>
)

export default Home;